import { render, staticRenderFns } from "./Fenzhi.vue?vue&type=template&id=4107782c&scoped=true&"
import script from "./Fenzhi.vue?vue&type=script&lang=js&"
export * from "./Fenzhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107782c",
  null
  
)

export default component.exports